export enum ProductDashboardChartsViewProps {
  HEADING = 'Product Dashboard',
  CHART_ONE_HEADING = 'CO\u2082e Of Each Life Cycle Stage',
  CHART_TWO_HEADING = 'Breakdown Of Each Life Cycle Stage',
  CARD_ONE_HEADING = 'Total CO\u2082e Of Annual Production',
  CARD_TWO_HEADING = 'Consumer Facing Carbon Footprint Label',
  EDIT_HEADING = 'Set Total CO\u2082e goal For The Annual Production',
  DQR_SCORE = 'Product DQR Score',
  Data_Quality_Indicators = 'Data Quality Indicators',
  Data_Quality_Rating = 'Data Quality Rating',
  Rating = 'Rating',
  Time = 'Time',
  Completeness = 'Completeness',
  Reliability = 'Reliability',
  Geography = 'Geography',
  Technology = 'Technology',
  DQR_HEADING = 'Data quality report',
  EDIT_GOAL_HEADING = `Set Total CO\u2082e Goal For The Annual Production`,
  YEAR = 'Year',

  KGCO2 = 'kgCO₂e',
  YOY_TEXT = 'Emissions by Year',
}
